export default __webpack_public_path__ + "static/media/MirusiojoPeгemimas.7b920e56.svg";